import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './detail-product-thumbnail-style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

import { Loading } from '@atoms';
import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';
import DesktopDetailAddToCartButton from '@src/componentsNew/Buttons/AddToCartButton//DesktopDetailAddToCartButton';

import {
  product_product,
  product_product_variants,
} from '@components/ProductPage/ProductDetailPage/__generated__/product';
import { getPriceInfoFromProduct, formatPrice } from '@src/utils';
import { shouldShowElementAccordingToDomain, goToGlobalStore } from '@src/utils/domainCheck';

interface IProps {
  product: product_product;
  selectedVariant?: product_product_variants | null;
  refetch?: any;
  showVariants: boolean;
}

const DetailProductThumbnail = ({ product, selectedVariant = null, refetch, showVariants }: IProps) => {
  const isComDomain = useIsComDomain();

  const { originalPrice, finalPrice, discountPercent, isOnSale } = getPriceInfoFromProduct(product);

  return (
    (product && (
      <div className="detail-product-thumbnail-wrapper">
        <div className="product-image-wrapper">
          <LazyLoadImage className="product-image" src={product.thumbnail.url} alt={product.name} effect="blur" />
        </div>

        <div className="product-description-wrapper">
          <Typography cName="brand-name" variant="subtitle1" component="span" style={{ color: '#212121' }}>
            {product.brand}
          </Typography>

          <div className="product-name">
            <Typography cName="product-name" variant="body1" component="span" style={{ color: '#212121' }}>
              {product.name}
            </Typography>
          </div>

          <div className="final-price-wrapper">
            {isOnSale && (
              <Typography variant="h7" component="span" style={{ color: '#F82296' }}>
                {discountPercent}%
              </Typography>
            )}
            <Typography variant="h7" component="span" style={{ color: '#212121' }}>
              {formatPrice(finalPrice)}
            </Typography>
            {isOnSale && (
              <Typography variant="strikethrough1" component="span" style={{ color: '#666666' }}>
                {formatPrice(originalPrice)}
              </Typography>
            )}
          </div>
        </div>

        {/* Domain Revert Comment */}
        {/* {
          shouldShowElementAccordingToDomain(isComDomain, product.productType.isMgs) ? (
            <DesktopDetailAddToCartButton
              isThumbnail={true}
              product={product}
              selectedVariant={selectedVariant}
              refetch={refetch}
              showVariants={showVariants}
            />
          ) : (
            !isComDomain ?
              <Button
                data-text="Go to Global Store"
                cName="go-global-store-btn"
                variant="outlined"
                size="medium"
                onClick={(e) => goToGlobalStore(e, false, product?.urlForGraphql)} />
              : null
          )
        } */}
        <DesktopDetailAddToCartButton
          isThumbnail={true}
          product={product}
          selectedVariant={selectedVariant}
          refetch={refetch}
          showVariants={showVariants}
        />
      </div>
    )) || <Loading />
  );
};

export default DetailProductThumbnail;
